'use client';

import { useEffect, useState } from 'react';
import { useConnectionStatusSubscription } from '@frameio/shared/integrations/gql/subscriptions/generated/ConnectionStatusSubscription';
import { AlertBanner, useGlobalErrorContext } from '@frameio/vapor';
import { BannerWrapper } from './BannerWrapper';
import TEXT from './generated/TEXT/NetworkStatusUXPBanner';

TEXT.DEFINE({
  /** Title shown when UXP connection is offline */
  offlineBannerTitle: "Looks like you're offline",
});

export function NetworkStatusUXPBanner() {
  const { hasGlobalErrorState, setHasGlobalErrorState } =
    useGlobalErrorContext();
  const [isOffline, setIsOffline] = useState(false);

  useConnectionStatusSubscription({
    context: {
      resolveWithUXP: true,
    },
    onData: ({ data }) => {
      const isConnected = data?.data?.connectionStatusChanged;
      if (isConnected === undefined) return;
      setIsOffline(!isConnected);
    },
  });

  useEffect(() => {
    if (hasGlobalErrorState && !isOffline) {
      setHasGlobalErrorState(false);
    } else if (!hasGlobalErrorState && isOffline) {
      setHasGlobalErrorState(true);
    }
  }, [hasGlobalErrorState, isOffline, setHasGlobalErrorState]);

  if (!isOffline) {
    return null;
  }

  return (
    <BannerWrapper>
      <AlertBanner title={TEXT.offlineBannerTitle} variant="error" />
    </BannerWrapper>
  );
}
